import { Dropdown, MenuProps } from 'antd';
import React from 'react';

import { MoreOutlined } from '@ant-design/icons';
import { useDimensionWorkflow, useTopPanelStore } from '@hooks';
import { useCustomDimensionPanelStore } from '@src/emp-3.0/components/custom-dimension/custom-dimension-panel/store';
import { useCustomDimensionStore } from 'emp-3.0/components/Dimensions/store';
import { ICustomDimensionsItem } from '@src/emp-3.0/types';
import { trackNewCustomDimension } from '@src/sensor';
import { useCreatePermissions } from '@src/hooks/usePermissions';
import { useIsNewWorkflowPage } from '@hooks/useNewWorkflow';
import { generateFilter } from '@hooks/useHandleFilter';
import { mappedEventDimensionType } from '@src/common/constant/enum';
import { useNavigate } from 'react-router-dom';

interface IProps {
  dimension: ICustomDimensionsItem;
}

export const DimensionKebab: React.FC<IProps> = ({ dimension }) => {
  const navigate = useNavigate();
  const isNewWorkflow = useDimensionWorkflow();
  const isNewWorkflowPage = useIsNewWorkflowPage();

  const { openCustomDimensionPanel, resetCustomDimensionPanelStore } = useTopPanelStore();

  const { attribute_name } = dimension;

  const { setCustomDimensionPayload, setAttributeFiltersPayload } = useCustomDimensionPanelStore(
    (state) => state,
  );
  const {
    setCustomDimensionPayload: setCustomDimensionPayloadInNewWorkflow,
    setCreateFrom,
    setAttributeFiltersPayload: setAttributeFiltersPayloadInNewWorkflow,
  } = useCustomDimensionStore((state) => state);

  const filters = [
    [generateFilter(mappedEventDimensionType.merged_event_tag_key, attribute_name, 0)],
  ];

  const hasCreate = useCreatePermissions();

  const handleMenuItemClick = async ({ key }) => {
    if (!dimension) return;
    const customDimensionPayload = {
      display_name: '',
      attribute_name,
      mapped_event_names: [],
    };
    // new dimension builder
    if (isNewWorkflow && key === 'create') {
      setAttributeFiltersPayloadInNewWorkflow(filters);
      setCustomDimensionPayloadInNewWorkflow(customDimensionPayload);
      if (!isNewWorkflowPage) {
        setCreateFrom('kebab');
        navigate(`/workflow/dimension/new`);
      }
      return;
    }
    // old dimension builder
    resetCustomDimensionPanelStore();
    if (key === 'create') {
      setAttributeFiltersPayload(filters);
      setCustomDimensionPayload(customDimensionPayload);
      trackNewCustomDimension({
        elementType: 'div',
        elementId: 'dimension-kebab',
        type: 'create',
      });
    }
    openCustomDimensionPanel();
  };

  const items: MenuProps['items'] = [
    {
      key: 'create',
      label: (
        <span style={{ whiteSpace: 'nowrap' }}>
          {isNewWorkflowPage ? 'Set to Tag Key' : 'New Custom Dimension'}
        </span>
      ),
    },
  ];

  return (
    <div id="all-event-menu" onClick={(e) => e.stopPropagation()} style={{ height: '100%' }}>
      {hasCreate ? (
        <Dropdown
          data-testid="dimension-kebab"
          menu={{ items, onClick: handleMenuItemClick }}
          placement="bottomLeft"
          trigger={['click']}
          getPopupContainer={(triggerNode) =>
            triggerNode.parentElement?.parentElement?.parentElement ?? document.body
          }
        >
          <MoreOutlined
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
            }}
          />
        </Dropdown>
      ) : null}
    </div>
  );
};
